const EVENT_TYPES = Object.freeze({
    USER_PROPERTIES: 'userProperties',
    QUIZ_PAGE_VISITED: 'quiz_page_visited',
    QUIZ_STARTED: 'quiz_started',
    QUIZ_QUESTION_VISITED: 'quiz_question_visited',
    QUIZ_COMPLETED: 'quiz_completed',
    PLAN_LOADER_PAGE_VISITED: 'plan_loader_page_visited',
    EMAIL_PAGE_VISITED: 'email_page_visited',
    EMAIL_SUBMITTED: 'email_submitted',
    SALE_PAGE_VISITED: 'sale_page_visited',
    FIRST_PLAN_VIEWED: 'first_plan_viewed',
    PLAN_SELECTED: 'plan_selected',
    LETTERS_BONUS_TOGGLED: 'letters_bonus_toggled',
    LETTERS_BONUS_AUTO_DISABLED: 'letters_bonus_auto_disabled',
    LETTERS_BONUS_PLAN_AUTO_SWITCHED: 'letters_bonus_plan_auto_switched',
    SALE_CHECKOUT_INITIATE: 'sale_initiate_checkout',
    SALE_CHECKOUT_PAGE_VISITED: 'sale_checkout_page_visited',
    SALE_CHECKOUT_CLICK_PAY: 'sale_checkout_click_pay',
    UPSELL_LETTERS_PAGE_VISITED: 'upsell_letters_page_visited',
    UPSELL_PAGE_CLICK_PAY: 'upsell_page_click_pay',
    UPSELL_PAGE_SKIPPED: 'upsell_page_skipped',
    QUIZ_START_CLICKED: 'quiz_start_clicked',
    START_PAGE_VISITED: 'start_page_visited',
    CANCEL_ANYTIME_BLOCK_VIEWED: 'cancel_anytime_block_viewed',
    PAUSE_PAGE_VISITED: 'pause_page_visited',
    PRODUCT_PAGE_VISITED: 'product_page_visited',
    PLAN_GRAPH_PAGE_VISITED: 'plan_graph_page_visited',
    REVIEW_PAGE_VISITED: 'review_page_visited',
    RESULT_PAGE_VISITED: 'result_page_visited',
    PROFILE_PAGE_VISITED: 'profile_page_visited',
    NAME_PAGE_VISITED: 'name_page_visited',
    NAME_SUBMITTED: 'name_submitted',
    PRESALE_PAGE_VISITED: 'presale_page_visited'
});
const AMPLITUDE_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.QUIZ_PAGE_VISITED]: 'quiz_page_visited',
    [EVENT_TYPES.QUIZ_STARTED]: 'quiz_started',
    [EVENT_TYPES.QUIZ_QUESTION_VISITED]: ({ questionNumber }) => `quiz_question${questionNumber}_visited`,
    [EVENT_TYPES.QUIZ_COMPLETED]: 'quiz_completed',
    [EVENT_TYPES.PLAN_LOADER_PAGE_VISITED]: 'plan_loader_page_visited',
    [EVENT_TYPES.EMAIL_PAGE_VISITED]: 'email_page_visited',
    [EVENT_TYPES.EMAIL_SUBMITTED]: 'email_submitted',
    [EVENT_TYPES.SALE_PAGE_VISITED]: 'sale_page_visited',
    [EVENT_TYPES.FIRST_PLAN_VIEWED]: 'first_plan_viewed',
    [EVENT_TYPES.PLAN_SELECTED]: 'plan_selected',
    [EVENT_TYPES.LETTERS_BONUS_TOGGLED]: 'letters_bonus_toggled',
    [EVENT_TYPES.LETTERS_BONUS_AUTO_DISABLED]: 'letters_bonus_auto_disabled',
    [EVENT_TYPES.LETTERS_BONUS_PLAN_AUTO_SWITCHED]: 'letters_bonus_plan_auto_switched',
    [EVENT_TYPES.SALE_CHECKOUT_PAGE_VISITED]: 'sale_checkout_viewed',
    [EVENT_TYPES.SALE_CHECKOUT_CLICK_PAY]: 'sale_checkout_click_pay',
    [EVENT_TYPES.SALE_CHECKOUT_INITIATE]: 'checkout_initiated',
    [EVENT_TYPES.UPSELL_LETTERS_PAGE_VISITED]: 'upsell_letters_page_visited',
    [EVENT_TYPES.UPSELL_PAGE_CLICK_PAY]: 'upsell_page_click_pay',
    [EVENT_TYPES.UPSELL_PAGE_SKIPPED]: 'upsell_page_skipped',
    [EVENT_TYPES.QUIZ_START_CLICKED]: 'quiz_start_clicked',
    [EVENT_TYPES.START_PAGE_VISITED]: 'start_page_visited',
    [EVENT_TYPES.CANCEL_ANYTIME_BLOCK_VIEWED]: 'cancel_anytime_block_viewed',
    [EVENT_TYPES.PAUSE_PAGE_VISITED]: ({ pauseNumber }) => `pause_page${pauseNumber}_visited`,
    [EVENT_TYPES.PRODUCT_PAGE_VISITED]: ({ productNumber }) => `product_page${productNumber}_visited`,
    [EVENT_TYPES.PLAN_GRAPH_PAGE_VISITED]: 'plan_graph_page_visited',
    [EVENT_TYPES.REVIEW_PAGE_VISITED]: 'review_page_visited',
    [EVENT_TYPES.RESULT_PAGE_VISITED]: 'result_page_visited',
    [EVENT_TYPES.PROFILE_PAGE_VISITED]: 'profile_page_visited',
    [EVENT_TYPES.NAME_PAGE_VISITED]: 'name_page_visited',
    [EVENT_TYPES.NAME_SUBMITTED]: 'name_submitted',
    [EVENT_TYPES.PRESALE_PAGE_VISITED]: 'presale_page_visited'
});

const META_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.EMAIL_SUBMITTED]: 'Email submitted',
    [EVENT_TYPES.SALE_CHECKOUT_INITIATE]: 'InitiateCheckout'
});

const GROWTHBOOK_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.QUIZ_START_CLICKED]: 'quiz_start_clicked'
});

export {
    EVENT_TYPES,
    AMPLITUDE_EVENT_TYPES,
    META_EVENT_TYPES,
    GROWTHBOOK_EVENT_TYPES
};
